import * as React from 'react';

const Apple24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#000",
    d: "M15.646 5.199Q16.749 3.9 16.749 2.4q0-.198-.02-.4-.77.04-1.633.458a4.5 4.5 0 0 0-1.426 1.061c-.75.84-1.171 1.868-1.171 2.828q.001.2.023.38c1.164.093 2.237-.5 3.124-1.528"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#000",
    d: "M19.602 15.75q-1.378-1.266-1.399-3.181-.023-2.458 2.255-3.827-1.273-1.792-3.822-1.994-.94-.08-2.298.404-1.439.522-1.69.523-.336-.002-1.525-.444-1.191-.442-1.922-.443a5 5 0 0 0-2.485.695 5.1 5.1 0 0 0-1.838 1.842Q3.999 10.78 4 12.79q0 1.755.65 3.627.604 1.733 1.545 3.043.877 1.228 1.462 1.733.916.844 1.837.805.605-.019 1.588-.413.981-.392 1.836-.392.817 0 1.787.392.969.393 1.66.392.96-.022 1.796-.784.54-.465 1.398-1.674.627-.886 1.085-1.933.189-.444.356-.927a4.6 4.6 0 0 1-1.398-.909"
  }
));
Apple24.Size = 24;
Apple24.Title = "Apple";

export { Apple24 as default };
